import { useContext } from "react";
import AuthenticationContext from "./authentication-context.ts";

const useAuthenticationContext = () => {
    const context = useContext(AuthenticationContext);
    if (!context) {
        throw new Error("useAuthenticationContext must be used within a AuthenticationContextProvider");
    }

    return context;
}

export default useAuthenticationContext;